<template>
  
  <div>

    <v-dialog
      v-model="addCardDialog"
      max-width="400"
      transition="fade"
      :persistent="addingCard"
    >
      <v-card color="white">
        
        <v-card-title class="primary white--text text-xs-center" style="position: relative;">
          <v-btn
            absolute
            small
            fab
            top
            right
            flat
            color="white"
            style="top: 10px;"
            :disabled="addingCard"
            @click="addCardDialog = false"
          ><v-icon>fas fa-times</v-icon></v-btn>
          <h3 style="margin: 0 auto;">New Card</h3>
        </v-card-title>
        <v-card-text v-if="addCardLoading">
          <div class="spinner">
            <div class="double-bounce1"></div>
            <div class="double-bounce2"></div>
          </div>
        </v-card-text>
        <v-card-text v-else>
          
          <h4>Billing Name & Address</h4>
          <v-container fluid grid-list-md class="pa-0 ma-0">
            <v-layout row wrap class="mt-3">
              <v-flex xs12>
                <div class="field-label">Name on Card</div>
                <v-text-field
                  flat
                  solo
                  hide-details
                  class="pt-0"
                  v-model="billing_details.name"
                  :disabled="addingCard"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <div class="field-label">Street</div>
                <v-text-field
                  flat
                  solo
                  hide-details
                  class="pt-0"
                  v-model="billing_details.street"
                  :disabled="addingCard"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <div class="field-label">City</div>
                <v-text-field
                  flat
                  solo
                  hide-details
                  class="pt-0"
                  v-model="billing_details.city"
                  :disabled="addingCard"
                ></v-text-field>
              </v-flex>
              <v-flex xs3>
                <div class="field-label">State</div>
                <v-text-field
                  flat
                  solo
                  hide-details
                  class="pt-0"
                  v-model="billing_details.state"
                  :disabled="addingCard"
                ></v-text-field>
              </v-flex>
              <v-flex xs3>
                <div class="field-label">Zip</div>
                <v-text-field
                  flat
                  solo
                  hide-details
                  class="pt-0"
                  v-model="billing_details.postal"
                  :disabled="addingCard"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <div class="field-label">Country</div>
                <country-select
                  :prefill="billing_details.country"
                  @on-change="updateCountry"
                  :disabled="addingCard"
                ></country-select>
                
              </v-flex>
            </v-layout>
          </v-container>
          <h4 class="mt-4">Card Details</h4>
          <v-container fluid grid-list-md class="pa-0 ma-0">
            <v-layout row class="mt-2">
              <v-flex>
                <!--<stripe
                  ref="stripe"
                  @on-change="stripeChange"
                  @on-error="processNewStripeError"
                  @on-token="processNewStripeToken"
                ></stripe>-->
                <stripe
                  ref="stripe"
                  :billing-details="billing_details"
                  @on-change="stripeChange"
                  @on-setup-intent-complete="processStripeIntentComplete"
                  @on-setup-intent-error="processStripeIntentError"
                ></stripe>
              </v-flex>
            </v-layout>
          </v-container>
          <v-layout justify-center>
            <v-flex shrink>
              <v-btn color="primary" @click="processCard" :loading="addingCard" :disabled="addCardDisabled">Add Card</v-btn>
            </v-flex>
          </v-layout>
                  

        </v-card-text>
        <v-card-actions class="primary white--text">
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    
    <transition name="fade-up" mode="out-in">
      
      <v-container grid-list-lg fluid key="billing_content">
        
        <v-layout row justify-center>
          <v-flex style="max-width: 650px;">
            <v-layout row wrap class="text-xs-left">
              <v-flex xs12>
                <h3>Payment Methods</h3>
              </v-flex>
              <transition name="fade-up" mode="out-in">
                <v-flex v-if="cardsLoading" key="cards_loader" class="my-3">
                  <div class="spinner my-1">
                    <div class="double-bounce1"></div>
                    <div class="double-bounce2"></div>
                  </div>
                </v-flex>
                <v-flex v-else key="cards_container" class="my-3">
                  <v-layout column>
                    <v-flex v-if="!cards.length" class="grey lighten-2 text-xs-center pa-3">
                      You have no payment methods on file
                    </v-flex>
                    <v-flex v-else>
                      <v-container fluid grid-list-md px-0>
                        <v-layout row wrap justify-center>
                          <v-flex
                            v-for="card in cards"
                            :key="card.stripe_id"
                            xs12 sm6
                            style="position: relative;"
                          >
                            <v-btn 
                              v-if="allItemsReturned"
                              fab 
                              absolute 
                              color="primary" 
                              style="width: 24px; height: 24px; border-radius: 12px; top: -3px; right: 12px;"
                              @click="confirmRemove(card)"
                            >
                              <i class="fas fa-times"></i>
                            </v-btn>
                            <v-layout 
                              row 
                              class="pa-2 ma-0 elevation-1 grey lighten-3"
                              align-center
                            >
                              <v-flex class="text-xs-left">
                                <i class="fab fa-cc-visa fa-3x" v-if="card.type == 'visa'" />
                                <i class="fab fa-cc-amex fa-3x" v-if="card.type == 'amex'" />
                                <i class="fab fa-cc-diners-club fa-3x" v-if="card.type == 'diners'" />
                                <i class="fab fa-cc-mastercard fa-3x" v-if="card.type == 'mastercard'" />
                                <i class="fab fa-cc-discover fa-3x" v-if="card.type == 'discover'" />
                                <i class="fab fa-cc-jcb fa-3x" v-if="card.type == 'jcb'" />
                              </v-flex>
                              <v-flex class="text-xs-right"> 
                                <div style="font-size: 1.1em;"><b>{{ card.name }}</b></div>
                                <div style="font-size: .8em;">XXXX-{{ card.last4 }}</div>
                              </v-flex>
                            </v-layout>

                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </transition>

              <!--<v-flex xs12>
                <div class="field-label">Street</div>
                <v-text-field
                  v-model="userData.address_line_1"
                  flat
                  solo
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <div class="field-label">City</div>
                <v-text-field
                  v-model="userData.address_city"
                  flat
                  solo
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs3>
                <div class="field-label">State</div>
                <v-text-field
                  v-model="userData.address_state"
                  flat
                  solo
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs3>
                <div class="field-label">Zip</div>
                <v-text-field
                  v-model="userData.address_postal"
                  flat
                  solo
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <div class="field-label">Country</div>
                <country-select
                  :prefill="userData.address_country"
                  @on-change="updateCountry"
                ></country-select>
              </v-flex>

              <v-flex xs12 class="mt-3 py-2 px-3 grey lighten-3" >
                <v-layout row align-center>
                  <v-flex v-if="false">
                    <h4>{{ user.cc_brand }} XXXX-{{ user.cc_last4 }}</h4>
                  </v-flex>
                  <v-flex class="text-xs-right">
                    <v-btn flat color="primary" @click="changeCardDialog = true">CHANGE</v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>-->

              <v-flex xs12 class="text-xs-center mb-5">
                <v-btn color="primary" @click="addCardDialog = true">ADD NEW</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

      </v-container>
    </transition>
  </div>

</template>

<script>

import CountrySelect from '@/components/helpers/CountrySelect';
import Stripe from '@/components/helpers/Stripe';

export default {
  name: 'AccountProfileBilling',
  components: {
    'country-select': CountrySelect,
    'stripe': Stripe
  },
  data () {
    return {
      openTripsLoading: true,
      cardsLoading: true,

      allItemsReturned: false,

      cards: {},
      billing_details: {
        name: this.$store.getters.user.first_name + ' ' + this.$store.getters.user.last_name,
        street: this.$store.getters.user.address_line_1,
        city: this.$store.getters.user.address_city,
        state: this.$store.getters.user.address_state,
        postal: this.$store.getters.user.address_postal,
        country: this.$store.getters.user.address_country
      },
      intent: null,

      addCardDialog: false,
      addCardLoading: true,
      addingCard: false,

      stripeComplete: false
    }
  },
  mounted: function() {
    this.getDataFromApi();
  },
  watch: {
    addCardDialog: function(newVal, oldVal) {
      if(newVal) this.getIntent();
    }
  },
  computed: {
    cdn: function() {
      return this.$root.cdn;
    },
    user: function() {
      return this.$store.getters.user;
    },
    addCardDisabled: function() {
      return (!this.billing_details.name || !this.billing_details.street || !this.billing_details.city || !this.billing_details.state || !this.billing_details.country || !this.billing_details.postal || !this.stripeComplete);
    }
  },
  methods: {
    getDataFromApi: function() {
      this.cardsLoading = true;
      this.$http.get('users/' + this.user.id + '?fields=cards&expand=cards')
        .then(response => {
          this.cards = response.data.cards;
        })
        .catch(error => {})
        .finally(() => {
          this.cardsLoading = false;
        })
      
      this.openTripsLoading = true;
      let params = [];
      params.push('f[user_id]=' + this.user.id);
      params.push('f[order.tracking_number][not_null]=');
      params.push('f[order.closed]=0');
      params.push('per-page=1');
      params.push('page=1');
      params.push('expand=order');

      this.$http.get('trips?' + params.join('&'))
        .then(response => {
          this.openTripsLoading = false;
          if(!response.data.items.length) this.allItemsReturned = true;
        })
        .catch(error => {
					
        });
      
    },
    getIntent: function() {
      if(this.intent) {
        this.addCardLoading = false;
        return;
      }
      this.addCardLoading = true;
      this.$http.get('users/' + this.user.id + '/add-intent')
        .then(response => {
          this.intent = response.data;
        })
        .catch(error => {
          this.intent = null;
          this.$swal.fire('Error', 'There was an issue preventing the card form from loading. Please try again');
          this.addCardDialog = false;
        })
        .finally(() => {
          this.addCardLoading = false;
        })
    },

    processCard: function() {
      this.addingCard = true;
      this.$refs.stripe.setupIntent(this.intent.client_secret);
    },

    updateCountry: function(val) {
      this.$set(this.billing_details, 'country', val);
    },

    stripeChange: function(e) {
      this.stripeComplete = (e.complete ? true : false);
    },
    processStripeIntentComplete(e) {
      //Update user billing information
      let params = {
        payment_method: e.setupIntent.payment_method
      }

      this.$http.post('users/' + this.user.id + '/payment-method', params)
        .then(response => {
          this.addCardDialog = false;
          this.stripeComplete = false;
          this.cards.push(response.data);
        })
        .catch(error => {
          this.$swal.fire('Error', 'There was an error adding your card. Please try again.');
        })
        .finally(() => {
          this.addingCard = false;
        });
      
    },
    processStripeIntentError(e) {
      this.$swal.fire('Error Adding Card', e.error.message);
      this.addingCard = false;
    },
    
    confirmRemove: function(card) {
      this.$swal.fire({
        title: 'Remove Card?',
        html: 'Are you sure you want to remove your card ending in ' + card.last4 + '?',
        confirmButtonText: 'Yes, Remove It',
        cancelButtonText: 'No, Keep It',
        showCancelButton: true,
        showConfirmButton: true
      }).then(response => {
        if(response.value) {
          let params
          this.$http.delete('users/' + this.user.id + '/payment-method?payment_method=' + card.stripe_id)
            .then(response => {

            })
            .catch(error => {})
          for(let i = 0; i < this.cards.length; i++) {
            if(this.cards[i].stripe_id == card.stripe_id) {
              this.cards.splice(i, 1);
              break;
            }
          }
        }
      });
    }
  }
}
</script>
